export default __webpack_public_path__ + "static/media/background.31fd75e2.jpg";